export const endpoints = {
  find: '/account/:id',
  query: '/accounts/query',
  userAccounts: '/user/:userId/accounts',
}
